import React, { Component } from 'react';
import PropTypes from 'prop-types';

import GlobalMenuGroupPres from './GlobalMenuGroupPres';

class GlobalMenuGroupContainer extends Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
  };

  state = {
    open: false,
  };

  toggleGroup = e => {
    e.stopPropagation();

    this.setState(state => ({ open: !state.open }));
  };

  render() {
    const { text, children } = this.props;

    return (
      <GlobalMenuGroupPres text={text} isOpen={this.state.open} toggleGroup={this.toggleGroup}>
        {children}
      </GlobalMenuGroupPres>
    );
  }
}

export default GlobalMenuGroupContainer;
